<template lang="pug">
.social-buttons(:class="$mq")
  img.instagram(
    src="@/assets/img/instagram-icon.png"
    title="Instagram @moonly_app"
    @click="open('instagram', 'https://www.instagram.com/moonly_app/')"
    alt="Instagram"
  )
  img.facebook(
    src="@/assets/img/facebook-icon.png"
    title="Facebook @MoonlyAppFR"
    @click="open('facebook', 'https://www.facebook.com/MoonlyAppFR')"
    alt="Facebook"
  )
  img.twitter(
    src="@/assets/img/twitter-icon.png"
    title="Twitter @moonly_app"
    @click="open('twitter', 'https://twitter.com/moonly_app')"
    alt="Twitter"
  )
  img.medium(
    src="@/assets/img/medium-icon.png"
    title="Medium Moonly App"
    @click="open('medium', 'https://medium.com/blog-moonlyapp')"
    alt="Medium"
  )
  img.email(
    src="@/assets/img/email-icon.png"
    title="Nous envoyer un email"
    @click="open('email', 'mailto:hello@moonlyapp.com')"
    alt="Email"
  )
</template>

<script>
export default {
  name: 'SocialButtons',
  methods: {
    open (social, url) {
      window.open(url, '_blank')
      this.$gtag.event('click', {
        event_category: 'external_link',
        event_label: 'social_network',
        value: social
      })
    }
  }
}
</script>

<style scoped lang="scss">
.social-buttons {
  display: grid;
  $item-count: 5;
  grid-template-columns: repeat($item-count, 37px);
  column-gap: 20px;

  &.large-desktop {
    grid-template-columns: repeat($item-count, 55px);
  }

  $shadow: drop-shadow(3px 3px 5px rgba(black, 0.05));
  img {
    width: 100%;
    transition: transform 0.03s ease-out;
    &:hover {
      transform: scale(1.1);
      cursor: pointer;
    }
    -webkit-filter: $shadow;
    filter: $shadow;
  }

  .instagram,
  .medium,
  .email {
    filter: invert(100%) $shadow;
  }
}
</style>
